import { TextField } from "@mui/material"
import { SelectFromItems } from "../forms/select"
import { checkPix, formatPix } from "./pixfunctions"
import { useEffect, useState } from "react"
import { formatCPF } from "../../../utils/formatcpf";

export function PixField({disabled,uniqueCpf,onUpdate}:{disabled?:boolean,uniqueCpf?:string,onUpdate?:(pixType:string,pix:string)=>any}){
    const [pixType,setPixType]=useState('EMAIL');
    const [pix,setPix]=useState('');
    useEffect(()=>{
         if(pixType=='CPF'&&uniqueCpf){
              setPix(formatCPF(uniqueCpf));
              return;
         }
         setPix('');
    },[pixType]);
    useEffect(()=>{
        if(onUpdate){
            onUpdate(pixType,pix);
        }
    },[pix])
    return (
        <div style={{marginTop:'10px'}}>
        <div style={{width:'200px',display:'inline-block'}}>
            <SelectFromItems disabled={disabled} label="Tipo Pix" defaultValue={pixType} items={['CPF','EMAIL','TELEFONE','ALEATORIA']} fullWidth={true} onChangeItem={(v)=>{setPixType(v)}}/>
        </div>
         <TextField error={!checkPix(pixType,pix)} helperText="Digite um pix."   sx={{marginLeft:"10px"}} value={pix} disabled={disabled||Boolean((uniqueCpf&&pixType=='CPF'))} label='Chave PIX' onChange={(v)=>{setPix(formatPix(pixType,v.target.value))}}/>
        </div>
    )
}